import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'lp-components'
import { AccountHolderForm } from '../forms'
import {
  API_KEY_MAP,
  AccountType,
  ContactType,
  isMemberBusinessAccountType,
} from 'types'
import {
  apiValuesWithMappedKeys,
  displayMemberName,
  formValuesWithMappedKeys,
  useToggle,
} from 'utils'
import { EDITOR_SECTION, logEditorOpened, logEditorSaved } from 'uxcam-service'

const propTypes = {
  account: AccountType.isRequired,
  fetchAccount: PropTypes.func.isRequired,
  formOpen: PropTypes.bool,
  primaryContact: ContactType.isRequired,
  updateAccount: PropTypes.func.isRequired,
}

const ADDRESS_LINE_ONE_KEYS = [
  'shippingstreet',
  'shippingcity',
  'shippingstate',
]
const ADDRESS_LINE_TWO_KEYS = ['shippingpostalcode', 'shippingcountry']

function AccountHolder({
  account,
  fetchAccount,
  formOpen = false,
  primaryContact,
  updateAccount,
}) {
  const [accountFormOpen, toggleAccountForm] = useToggle(formOpen)
  const isBusinessAccount = isMemberBusinessAccountType(
    account.account_detail_type__c
  )

  return (
    <div className="card">
      <header>
        <img
          src="/assets/images/icons/with-background/ST_YIcon_Account-Holder.svg"
          alt=""
          className="icon"
        />
        <h2>Account Holder Information</h2>
      </header>
      <div className="card-inner">
        {accountFormOpen ? (
          <AccountHolderForm
            isBusinessAccount={isBusinessAccount}
            toggleAccountForm={toggleAccountForm}
            primaryContact={primaryContact}
            initialValues={formValuesWithMappedKeys(
              account,
              API_KEY_MAP.ACCOUNT_KEY_MAP
            )}
            onSubmit={(formValues) => {
              const apiValues = apiValuesWithMappedKeys(
                formValues,
                API_KEY_MAP.ACCOUNT_KEY_MAP
              )
              apiValues.sfid = account.sfid
              apiValues.id = account.id
              return updateAccount(apiValues)
            }}
            onSubmitSuccess={() => {
              logEditorSaved(EDITOR_SECTION.ACCOUNT_HOLDER)
              fetchAccount(account.sfid)
              toggleAccountForm()
            }}
          />
        ) : (
          <div className="row">
            <div className="col-6">
              <h3>Account Holder</h3>
              <p>{displayMemberName(primaryContact) || 'N/A'}</p>
            </div>
            <div className="col-6">
              <h3>Mailing Address</h3>
              <Button
                onClick={() => {
                  logEditorOpened(EDITOR_SECTION.ACCOUNT_HOLDER)
                  toggleAccountForm()
                }}
                className="link-primary"
              >
                (Edit)
              </Button>
              <p>{address(account)}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

// Drop empty fields so partial addresses don't render with stray commas.
function address(account) {
  const lineOne = ADDRESS_LINE_ONE_KEYS
    .map((key) => account[key])
    .filter(Boolean)
    .join(', ')
  const lineTwo = ADDRESS_LINE_TWO_KEYS
    .map((key) => account[key])
    .filter(Boolean)
    .join(' ')
  if (!lineOne && !lineTwo) return 'No address on file'
  return [lineOne, lineTwo].filter(Boolean).join(' ')
}

AccountHolder.propTypes = propTypes

export default AccountHolder
